import { Component, OnInit, Input } from '@angular/core';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import * as S3 from 'aws-sdk/clients/s3';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
    selector: 'product-view-slider',
    templateUrl: './product-view-slider.component.html',
    styleUrls: ['./product-view-slider.component.scss'],
    standalone: false
})
export class ProductViewSliderComponent implements OnInit {
  product: any;
  slides = [];
  slides2 = [];
  environment = environment
  productId: any;
  @Input() ImagesData: string
  constructor(private statePersist: StatePersistService, private activatedRoute: ActivatedRoute, private router: Router,private http:HttpClient) { }

  ngOnInit(): void {
    this.productId = this.activatedRoute.snapshot.paramMap.get('productid')
    this.product = this.statePersist.getLocalStorage('selectedProduct');
    this.statePersist.watchStorage().subscribe(message => {
      this.product = this.statePersist.getLocalStorage('selectedProduct');
      if(this.router.url.includes('product')){
        this.getImages()
      }
      
    })
    this.getImages()
  }

  checkImageValidity(url: string) {
    return new Observable<boolean>((observer) => {
      const img = new Image();
      img.onload = () => observer.next(true); 
      img.onerror = () => observer.next(false); 
      img.src = url; 
    });
  }

  urlExist(i: any) {
    let imageUrl = this.environment.s3_path + '/' + this.environment.product_image_folder + '/' + this.productId + "_" + i + '.jpg';
  
    this.checkImageValidity(imageUrl).subscribe(valid => {
      if (valid) {
          this.slides.push({ img: imageUrl });
          this.slides2.push({ img: this.environment.s3_path + '/' + this.productId + "_" + i + '.jpg' })
      } else {
        console.log('Image not found: ' + imageUrl);
      }
    });
  }

  getImages() {
    let i: number = 1;
    for (const item of this.ImagesData){
      let image = this.environment.s3_path + '/' + this.environment.product_image_folder + '/' + item
      let image2 = this.environment.s3_path + '/' + item
      this.slides.push({ img: image })
      this.slides2.push({ img: image2 })
    }
    
    

    // this.urlExist(1)
    // this.urlExist(2)
    // this.urlExist(3)
    
  }


  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 2,
    'centerPadding': '0',
    "dots": false,
    "infinite": true,
    "loop": true,
    "vertical": true,
    "verticalSwiping": true,
    "asNavFor": ".carousel1",
    "focusOnSelect": true,
    "centerMode": true,
    'responsive': [
      {
        'breakpoint': 767, 'settings': {
          'slidesToShow': 5,
          "dots": false,
          "vertical": false,
          "verticalSwiping": false,
          'centerPadding': '42px',
        }
      },
      {
        'breakpoint': 560, 'settings': {
          'slidesToShow': 4,
          "vertical": false,
          "variableWidth": true,
          "verticalSwiping": false,
          'centerPadding': '52px',
        }
      },
      {
        'breakpoint': 321, 'settings': {
          'slidesToShow': 4,
          "vertical": false,
          "variableWidth": true,
          "verticalSwiping": false,
          'centerPadding': '30px',
        }
      }
    ]
  };

  slideConfig2 = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": true,
    "loop": true,
    "arrows": false,
    "asNavFor": ".carousel",
    'fade': true
  };

}
